import { AxiosResponse } from "axios";
import { chatbotApi } from "..";

interface MailerRequest {
  email: string;
  content: string;
}

interface MailerResponse {
  message: string;
}

export const sendRecommendationEmail = async (
  data: MailerRequest
): Promise<MailerResponse> => {
  const response: AxiosResponse<MailerResponse> = await chatbotApi.post(
    `/mailer/recommendation`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
